import { RegistrationForm } from "@/components/auth/RegistrationForm";

const RegistrationPage = () => {
  return <RegistrationForm />;
};

export { RegistrationPage };
